import Swiper, { Navigation, Pagination } from 'swiper';

export default {
  init() {
    // JavaScript to be fired on all pages

    // Swiper
    Swiper.use([Navigation, Pagination]);

    new Swiper('.offers-swiper', {
      // Optional parameters
      freeMode: true,
      direction: 'horizontal',
      loop: false,
      centerInsufficientSlides: true,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 16,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
      },

      on: {
        init: function () {
            if (this.slides.length <= 1) {
              this.allowSlidePrev = this.allowSlideNext = false // disabling swiping
              this.el.querySelector('.swiper-button-prev').setAttribute('hidden', '') // hiding arrows prev&next
              this.el.querySelector('.swiper-button-next').setAttribute('hidden', '')
            }
        },
      },
    });

    new Swiper('.products-categories-swiper', {
      // Optional parameters
      slidesPerView: 'auto',
      spaceBetween: 10,
      grabCursor: true,
      history: {
        replaceState: true,
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js